const actions = {
    //ALl consents
    SET_DATA: 'consentTypes/SET_DATA',
    GET_DATA: 'consentTypes/GET_DATA',

    //Single consent
    SET_CONSENT: 'consentType/SET_CONSENT',
    GET_CONSENT: 'consentType/GET_CONSENT',
};

export default actions
